export default {
    routerName: '标签新增',
    tag: {
        icon: '图片',
        name: '标签名',
        status: '状态',
        open: '启用',
        close: '停用',
        sortOrder: '排序',
    },
};
